import _ from 'lodash';
import {
    SET_ALIGNMENT,
    SET_FONT,
    SET_TEXT,
    TOGGLE_BOLD,
    TOGGLE_ITALIC,
    RESET_TEXT_EDITOR,
    SET_TEXT_COLOR,
} from '../actions/actionCreators/textEditor';

const initialState = {
    text: '',
    alignment: 'left',
    bold: false,
    italic: false,
    color: {
        r: 0,
        g: 0,
        b: 0,
    },
    font: 'Arial',
};

export default function textEditor(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case SET_ALIGNMENT:
            newState.alignment = action.alignment;
            return newState;
        case SET_FONT:
            newState.font = action.font;
            return newState;
        case SET_TEXT:
            newState.text = action.text;
            return newState;
        case SET_TEXT_COLOR:
            newState.color = action.color;
            return newState;
        case TOGGLE_BOLD:
            newState.bold = !newState.bold;
            return newState;
        case TOGGLE_ITALIC:
            newState.italic = !newState.italic;
            return newState;
        case RESET_TEXT_EDITOR:
            return initialState;
        default:
            return state;
    }
}
